/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const initilaState = {
  rebateProgramCode: {},
  reqURACalcData: {
    rebateProgramCode: '',
    planType: '',
   // allManufacturers: 'No',
    quarter: null,
   // manufacturerId: null,
    // userId: localStorage.getItem('logInUser'),
    //runProcedure: '',
    //errorMessages: [],
  },
};

const reducer = (state = initilaState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_REBATE_PROGRAMS: {
      return { ...state, rebateProgramCode: action.payload };
    }
    case actionTypes.SET_REQ_URA_DATA: {
      return { ...state, reqURACalcData: action.payload };
    }
    case actionTypes.GET_MANUFACTURERS_BY_REQ_URA_CAL: {
      return { ...state, manufacturersByPQR: action.payload };
    }
    case actionTypes.CALCULATE_INVOICE: {
      return { ...state, calculateURA: action.payload };
    }
    case actionTypes.SET_DEFAULT_QTR: {
      return { ...state, defaultQtrURA: action.defaultQtrURA };
    }
    case actionTypes.SET_ERROR_MESSAGES_REQ_URA_CAL: {
      return { ...state, errorMessages: action.payload };
    }
    case actionTypes.RESET_REQUEST_URA_CALCULATION_STORE: {
      return { ...initilaState };
    }
    default:
      return state;
  }
};

export default reducer;
